var NotificationDuration;
(function (NotificationDuration) {
    NotificationDuration["Short"] = "SHORT";
    NotificationDuration["Regular"] = "REGULAR";
    NotificationDuration["Long"] = "LONG";
    NotificationDuration["Persist"] = "PERSIST";
})(NotificationDuration || (NotificationDuration = {}));
var NotificationPosition;
(function (NotificationPosition) {
    NotificationPosition["Top"] = "TOP";
    NotificationPosition["Right"] = "RIGHT";
    NotificationPosition["Bottom"] = "BOTTOM";
    NotificationPosition["Left"] = "LEFT";
    NotificationPosition["TopLeft"] = "TOP_LEFT";
    NotificationPosition["TopRight"] = "TOP_RIGHT";
    NotificationPosition["BottomLeft"] = "BOTTOM_LEFT";
    NotificationPosition["BottomRight"] = "BOTTOM_RIGHT";
})(NotificationPosition || (NotificationPosition = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["Primary"] = "PRIMARY";
    NotificationType["Info"] = "INFO";
    NotificationType["Alert"] = "ALERT";
    NotificationType["Warning"] = "WARNING";
    NotificationType["Success"] = "SUCCESS";
})(NotificationType || (NotificationType = {}));
var NotificationSize;
(function (NotificationSize) {
    NotificationSize["Small"] = "SMALL";
    NotificationSize["Medium"] = "MEDIUM";
    NotificationSize["Large"] = "LARGE";
})(NotificationSize || (NotificationSize = {}));

export { NotificationDuration, NotificationPosition, NotificationSize, NotificationType };
//# sourceMappingURL=models.js.map
